import LegalLayout from "@/components/LegalLayout";

export default function Kayttoehdot() {
  return (
    <LegalLayout title="Käyttöehdot" updated="kesäkuu 2026">
      <p>
        Käyttämällä Lahden Autokulma (Tepe Markkinointi Oy) -verkkosivustoa hyväksyt
        nämä käyttöehdot.
      </p>

      <div>
        <h2>1. Ilmoitukset ja hinnat</h2>
        <p>
          Sivustolla esitetyt autot, tiedot ja hinnat ovat suuntaa antavia eivätkä sido
          myyjää. Pidätämme oikeuden muutoksiin ja mahdollisiin virheisiin. Auton saatavuus
          varmistetaan aina liikkeestä.
        </p>
      </div>

      <div>
        <h2>2. Rahoituslaskuri</h2>
        <p>
          Rahoituslaskurin antama tulos on ainoastaan suuntaa antava arvio eikä ole
          rahoitustarjous. Lopullinen rahoitus, korko ja kulut vahvistetaan rahoitusyhtiön
          kanssa.
        </p>
      </div>

      <div>
        <h2>3. Immateriaalioikeudet</h2>
        <p>
          Sivuston sisältö, kuvat ja tavaramerkit ovat Tepe Markkinointi Oy:n (Lahden Autokulma){" "}
          tai sen kumppaneiden omaisuutta. Sisällön kopiointi ilman lupaa on kielletty.
        </p>
      </div>

      <div>
        <h2>4. Vastuunrajoitus</h2>
        <p>
          Emme vastaa sivuston käytöstä mahdollisesti aiheutuvista välillisistä vahingoista.
          Sivusto tarjotaan "sellaisena kuin se on".
        </p>
      </div>

      <div>
        <h2>5. Sovellettava laki</h2>
        <p>Näihin ehtoihin sovelletaan Suomen lakia.</p>
      </div>
    </LegalLayout>
  );
}
